import React from "react";
import { NodeProps, useReactFlow } from "reactflow";
import { operationType } from "../../../../../services/types";
import { Main, Styled } from "./style";
import { Select } from "../../../../form/select";
import { updateNodeValue } from "../../../../../services/method";
import axios from "axios";
import { webURL } from "../../../../../services/API";
import { Checkboxs } from "../../../../form/checkboxs";
import { SettingsBlock, settingsDataType } from "../../../../settingsBlock";
import { IoCheckmarkCircleOutline, IoWarningOutline } from "react-icons/io5";
import { ExpandedBlock } from "../../../expanded";

type KnowledgeProps = NodeProps<operationType> & {
   setChildMinimize?: (fn: (id: string) => void) => void;
   setChildSettings?: (fn: (id: string) => void) => void;
};

export function KnowledgeBase({ id, data, setChildMinimize, setChildSettings }: KnowledgeProps) {
   const { setNodes } = useReactFlow();
   const activeFolder = React.useMemo(() => data.value?.folders?.find((folder: any) => folder.isActive), [data.value?.folders]);
   const folderId = activeFolder?.id;
   const isAgentDecide = folderId === 'agent_decide';
   const [settings, setSettings] = React.useState<settingsDataType>({ isToggle: false });
   const [isExpanded, setIsExpanded] = React.useState(false);

   // --
   React.useEffect(() => {
      if (setChildMinimize) setChildMinimize(() => { setIsExpanded(prev => !prev) });
      if (setChildSettings) setChildSettings(() => { setSettings(prev => ({ ...prev, isToggle: !prev.isToggle })) });
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [setChildMinimize, setChildSettings]);

   // ---
   React.useEffect(() => {
      (async function () {
         const response = (await axios.get(`${webURL}/knowledge`)).data;
         const agentDecideOption = { id: 'agent_decide', name: 'Let AI Agent Decide', isActive: folderId === 'agent_decide' };
         updateNodeValue(id, setNodes, {
            folders: [
               agentDecideOption,
               ...response.map((item: any) => ({
                  id: item._id, name: item.name,
                  isActive: folderId ? folderId === item._id : false
               }))
            ]
         });
      })();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, []);

   // ---
   React.useEffect(() => {
      if (folderId && !isAgentDecide) {
         (async function () {
            const response = (await axios.get(`${webURL}/knowledge?folderId=${folderId}`)).data;
            updateNodeValue(id, setNodes, {
               files: response.files.map((file: any) => ({ id: file._id, type: file.type, name: file.name, url: file.url, isActive: true }))
            });
         })();
      } else if (isAgentDecide) {
         updateNodeValue(id, setNodes, { files: [] });
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [folderId]);

   // ---
   const handleSelectFolder = (selectId: number) => {
      updateNodeValue(id, setNodes, { folders: data.value?.folders.map((item: any) => ({ ...item, isActive: item.id === selectId })) });
   }

   // ---
   const filesLengthActive = data.value?.files?.filter((item: any) => item.isActive)?.length || 0;
   const isWarning = !isAgentDecide && !filesLengthActive;

   return (<>
      <SettingsBlock nodeId={id} data={settings} setData={setSettings} />
      <Main>
         {isWarning ? <>
            <div id="warning"></div>
            <span id="warningIcon"><IoWarningOutline size={21} /></span>
         </> : data.output ? <>
            <div id="ran"></div>
            <span id="ranIcon"><IoCheckmarkCircleOutline size={21} /></span>
         </> : null}
         {isExpanded ? <ExpandedBlock
            data={{ id, ...data }}
            handleClose={() => setIsExpanded(false)}
            isWarning={isWarning}
            styleParent={(data.value?.files?.length ? { right: '-101.5px' } : {})}
            style={{ width: '350px' }}
         ><Styled>
            <Select title="Folder" data={data.value?.folders || []} handleSelectItem={handleSelectFolder} isSmall={true} />
            {!isAgentDecide && data.value?.files?.length ? <div className="filesEdit">
               <h3 className="title" style={{ backgroundColor: data.background, color: '#fff' }}>Files ({filesLengthActive}/{data.value?.files?.length})</h3>
               <div className="scroll nowheel">
                  <Checkboxs
                     data={data.value.files}
                     handelCheckbox={(fileId: any, value?: boolean) => {
                        updateNodeValue(id, setNodes, {
                           files: data.value.files.map((item: any) => {
                              if (item.id === fileId) return ({ ...item, isActive: !value })
                              else return item;
                           })
                        });
                     }}
                  />
               </div>
            </div> : null}
         </Styled></ExpandedBlock> : null}
      </Main>
   </>);
}